import React from 'react'
import Button from '../common/Button'
import Modal from '../common/Modal'

import * as yup from 'yup'
import { Controller, FieldErrors, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Input, { InputStyles } from '../common/Input'
import PhoneNumberInput from '../common/PhoneNumberInput'
import { useCreateAsDispatcherMutation } from '@/services/customers/customers'
import { toast } from 'react-toastify'
import { ChangePhotoPart } from '../common/ChangePhotoPart'

interface Props {
    isOpen: boolean
    onClose: () => void
}

const customerFormSchema = yup.object({
    photo: yup.mixed().nullable().optional(),
    fullName: yup.string().required('Full Name is required'),
    email: yup
        .string()
        .email('Invalid email format')
        .required('Email is required'),
    phone: yup
        .string()
        .required('Phone Number is required')
        .matches(
            /^(\+?\d{1,3}[-.\s]?)?(\(?\d{1,4}\)?[-.\s]?)?\d{1,4}([-.\s]?\d{1,9})$/,
            'Phone number must be a valid format (e.g., +1234567890, (123) 456-7890)',
        ),
    password: yup
        .string()
        .required('Password is required')
        .min(6, 'Password must be at least 6 characters')
        .max(30, 'Password cannot exceed 30 characters'),
})

export type CustomerFormValues = yup.InferType<typeof customerFormSchema>

const AddCustomerModal = ({ isOpen, onClose }: Props) => {
    const [createAsDispatcher] = useCreateAsDispatcherMutation()
    const {
        control,
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(customerFormSchema),
    })

    const onSubmit = async (data: CustomerFormValues) => {
        console.log(data)
        const response = await createAsDispatcher(data).unwrap()
        if (response?.success) {
            toast.success('Customer created successfully!')
            onClose()
        } else {
            toast.error(response?.message || 'Something went wrong')
        }
    }
    const onError = (errots: FieldErrors<CustomerFormValues>) =>
        console.log(errots)

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Add Customer"
        >
            <div className="modal__body p-0">
                <form
                    className="custom-form"
                    onSubmit={handleSubmit(onSubmit, onError)}
                >
                    <div className="custom-form-body mb-42">
                        <div className="row gutters-16">
                            {/* <div className="col-12">
                                <Controller
                                    control={control}
                                    name="photo"
                                    render={({ field }) => (
                                        <ChangePhotoPart
                                            onChange={field.onChange}
                                            error={errors.photo?.message}
                                        />
                                    )}
                                />
                            </div> */}
                            <div className="col-12">
                                <Input
                                    inputStyle={InputStyles.outline}
                                    label="Full Name"
                                    placeholder="Enter full name..."
                                    error={errors.fullName?.message}
                                    {...register('fullName')}
                                />
                            </div>
                            <div className="col-12">
                                <Input
                                    inputStyle={InputStyles.outline}
                                    label="Email"
                                    placeholder="Enter email address..."
                                    error={errors.email?.message}
                                    {...register('email')}
                                />
                            </div>
                            <div className="col-12">
                                <Controller
                                    control={control}
                                    name="phone"
                                    render={({ field }) => (
                                        <PhoneNumberInput
                                            label="Phone Number"
                                            onChange={field.onChange}
                                            value={field.value}
                                            error={errors.phone?.message}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-12">
                                <Input
                                    inputStyle={InputStyles.outline}
                                    label="Password"
                                    placeholder="Enter Password..."
                                    error={errors.password?.message}
                                    type="password"
                                    togglePasswordShow
                                    {...register('password')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal__footer justify-end">
                        <Button
                            loading={isSubmitting}
                            type="submit"
                            className="btn--primary"
                        >
                            Create User
                        </Button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default AddCustomerModal
